
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Erika tritt ihre letzte Reise an. Sie wird in einen Tiertransporter geladen und kommt auf den Schlachthof.
Dort wird sie mit anderen Kühen in eine Sammelbox getrieben. Über eine vergitterte Schleuse gelangt sie in den
Schlachtraum, wo sie mit einem Bolzenschuss betäubt und mit einer Kette an einem Bein aufgehängt wird. Sie ist
noch nicht tot. Der Metzger durchschneidet eine Hauptschlagader oder setzt den Bruststich zur Entblutung.
Der Sauerstoffmangel im Gehirn von Erika führt zum Tod. Erika liefert grösstenteils nur noch sogenanntes
Verarbeitungsfleisch; dieses wird für Würste, Trockenfleisch, Hackfleisch und weitere Produkte verwendet.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;